import { render, staticRenderFns } from "./codeView.vue?vue&type=template&id=5297c0a5&scoped=true"
import script from "./codeView.vue?vue&type=script&lang=js"
export * from "./codeView.vue?vue&type=script&lang=js"
import style0 from "./codeView.vue?vue&type=style&index=0&id=5297c0a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5297c0a5",
  null
  
)

export default component.exports